import { render, staticRenderFns } from "./BusinessHeader.vue?vue&type=template&id=ddf9a5ba&scoped=true&"
import script from "./BusinessHeader.vue?vue&type=script&lang=js&"
export * from "./BusinessHeader.vue?vue&type=script&lang=js&"
import style0 from "./BusinessHeader.vue?vue&type=style&index=0&id=ddf9a5ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf9a5ba",
  null
  
)

export default component.exports